/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const WorkbenchOverviewResponse = zod
	.object({
		api_summary: zod
			.object({
				avg_duration_ms: zod.number().describe('Average duration in ms'),
				p95_duration_ms: zod.number().describe('95th percentile duration in ms'),
				total_errors: zod.number().describe('Total errors in range'),
				total_requests: zod.number().describe('Total requests in range')
			})
			.describe('API request summary'),
		api_timeseries: zod.array(
			zod
				.object({
					avg_duration_ms: zod.number().describe('Average duration in ms'),
					errors: zod.number().describe('Failed requests'),
					p50_duration_ms: zod.number().describe('50th percentile duration in ms'),
					p95_duration_ms: zod.number().describe('95th percentile duration in ms'),
					requests: zod.number().describe('Total requests'),
					ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp')
				})
				.describe('API request timeseries data point')
		),
		delivery_timeseries: zod.array(
			zod
				.object({
					attempts: zod.number().describe('Total delivery attempts'),
					avg_latency_ms: zod.number().nullable().describe('Average latency in ms'),
					delivered: zod.number().describe('Successful deliveries'),
					failed: zod.number().describe('Failed deliveries'),
					max_latency_ms: zod.number().nullable().describe('Maximum latency in ms'),
					min_latency_ms: zod.number().nullable().describe('Minimum latency in ms'),
					p95_latency_ms: zod.number().nullable().describe('95th percentile latency in ms'),
					ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp')
				})
				.describe('Delivery timeseries data point')
		),
		error_by_route: zod.array(
			zod
				.object({
					errors: zod.number().describe('Error count'),
					route_key: zod.string().describe('HTTP method and route pattern'),
					ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp')
				})
				.describe('Error count for a specific route at a time bucket')
		)
	})
	.describe('Workbench overview with API and delivery metrics');

export type WorkbenchOverviewResponse = zod.input<typeof WorkbenchOverviewResponse>;
export type WorkbenchOverviewResponseOutput = zod.output<typeof WorkbenchOverviewResponse>;
